import React, { Component } from 'react';
import { adminservice } from '../../../services/admin.service';

const validFileFormats = ["pdf", "xls", "xlsx","doc","docx"];
class UploadQuestionBankModel extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            selectedEditCategory:'1',
            selectedEditSubCategory:'1',
            showSelectedEditCategoryError:false,
            selectedQuestionId:'0',
            showSelectedEditSubCategoryError:false,
            documentFile: null,
            category:[],
            subCategory:[],
            fileInputKey: this.generateRandomString(),
            errorFile: false,
            folderName:'Questionbank',
            selectedQuestionId:'0',
            showSucessMessage:false,
        };
    }

    componentDidMount=()=>{
        this.setState({
            category : this.props.category,
            subCategory : this.props.subCategory,
            selectedQuestionId:this.props.selectedQuestionId,
            selectedEditCategory:this.props.selectedEditCategory,
            selectedEditSubCategory:this.props.selectedEditSubCategory,
        })
    }
    generateRandomString = () => {
        return Math.random().toString(36);
    };

    saveQuestionBank=async()=>{
        try{
            
                const{
                    selectedEditCategory,
                    selectedEditSubCategory,
                    documentFile,
                    folderName,
                    selectedQuestionId,
                }=this.state;

                let data = new FormData();
                data.append("file", documentFile);
                data.append("category", selectedEditCategory);
                data.append("subcategory", selectedEditSubCategory);
                data.append("folderName",folderName);
                data.append("questionId",selectedQuestionId);

                var response = await  adminservice.SaveQuestionBank(data);
                if(response.status === 200){
                    this.setState({showSucessMessage:true})
                    this.props.getQuestionBankValues();
                    this.props.clearEditModel();
                }
        }catch(e){
            return "";
        }
    }

    onFileChange = (e) => {
        if (!this.isValidFile(e.target.value)) {
          this.setState({
            fileInputKey: this.generateRandomString(),
            documentFile: null,
            errorFile: true,
            assignmentFileList:null,
          });
          return;
        }
    
        let file = e.target.files[0];

        this.setState({
          documentFile: file,
          errorFile: false,
        });
    };

    isValidFile = (value) => {
        //check if value is blank
        if (!value) return false;
    
        //regex to get file extension
        var re = /(?:\.([^.]+))?$/;
    
        //second item in the array will be the extension
        let ext = re.exec(value)[1];
        return validFileFormats.some((x) => x === ext);
    };

    OnEventChange(e) {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
            showSelectedEditCategoryError:false,
            showSelectedEditSubCategoryError:false,

      }
    )}

    validate=()=>{
        try{
            const{
                selectedEditCategory,
                selectedEditSubCategory
            }=this.state;
            let val = true;

            if(selectedEditCategory === ""){
                this.setState({
                    showSelectedEditCategoryError:true,
                })
                val=false;
            }
            if(selectedEditSubCategory === ""){
                this.setState({
                    showSelectedEditSubCategoryError:true,
                })
                val=false;
            }

            if (this.state.documentFile == null) {
                this.setState({
                  errorFile: true,
                });
                
                val=false;
            }

            if(val === false){
                return val;
            }else{
                this.saveQuestionBank();
            }
        }catch(e){
            return "";
        }
    }
    render() {
        const{
            selectedEditCategory,
            selectedEditSubCategory,
            showSelectedEditCategoryError,
            showSelectedEditSubCategoryError,
            category,
            subCategory,
            fileInputKey,
            errorFile,
            showSucessMessage,
        }=this.state;
        return (
            <div className="modal update-unit-popup" id="myModal">
            <div className="modal-dialog modal-dialog-centered" style={{maxWidth: '600px'}}>
                <div className="modal-content">
                {/* Modal Header */}
                <div className="modal-header">
                    <h4 className="modal-title">Edit Question Banks</h4>
                    <button type="button" className="btn-close" onClick={()=>this.props.clearEditModel()}>X</button>
                </div>
                {/* Modal body */}
                <div className="modal-body" style={{overflowX: 'auto'}}>
                    <table className="table">
                    <tbody>
                        <tr>
                        <td className="about-filter"><h4 style={{fontSize: '22px'}}>Select Category:</h4></td>
                        <td>
                            <select 
                                className="quest-bank-form form-select form-select-lg mb-2" 
                                aria-label=".form-select-lg example"
                                value={selectedEditCategory}
                                name="selectedEditCategory"
                                onChange={this.OnEventChange.bind(this)}
                                >
                                {category.map((item)=>{
                                    return(
                                        <option value={item.categoryID}>{item.categoryName}</option>
                                    )
                                })}
                            
                            </select>
                            {showSelectedEditCategoryError && (
                                <small
                                id="emailHelp"
                                className="form-text"
                                style={{ color: "red" }}
                            >
                                Please select a category
                            </small>
                            )}
                        </td>
                        </tr>
                        <tr>
                        <td className="about-filter"><h4 style={{fontSize: '22px'}}>Select Sub Category:</h4></td>
                        <td>
                            <select 
                                className="quest-bank-form form-select form-select-lg mb-2" 
                                aria-label=".form-select-lg example"
                                value={selectedEditSubCategory}
                                name="selectedEditSubCategory"
                                onChange={this.OnEventChange.bind(this)}
                            >
                            {subCategory.map((item)=>{
                                    return(
                                        <option value={item.subCategoryID}>{item.subCategoryName}</option>
                                    )
                                })}
                            
                            </select>
                            {showSelectedEditSubCategoryError && (
                                <small
                                id="emailHelp"
                                className="form-text"
                                style={{ color: "red" }}
                            >
                                Please select a sub category
                            </small>
                            )}
                        </td>
                        </tr>
                        <tr>
                        <td className="about-filter"><h4 style={{fontSize: '22px'}}>Replace Document:</h4></td>
                        <td>
                            <input 
                                accept=".pdf,.xlsx, .xls,.doc,.docx" 
                                type="file" 
                                id="myfile" 
                                name="documentFile"
                                onChange={this.onFileChange}
                                key={fileInputKey || ""}
                            /><br />
                            <p>(.pdf, .doc and .xls only)</p>
                            {errorFile && (
                                <small
                                id="emailHelp"
                                className="form-text"
                                style={{ color: "red" }}
                                >
                                Please select a file
                                </small>
                            )}
                            {showSucessMessage && (
                            <div id="thank_you" className="alert alert-success alert-dismissible" style={{ fontSize: '16px'}}>
                                {/* <a onclick="closeForm()" className="close" style={{float: 'right', color: 'black', textDecoration: 'none', fontSize: '24px'}} data-dismiss="alert" aria-label="close">×</a> */}
                                <button type="button" className="btn-close" data-bs-dismiss="alert" />
                                File Updated.
                            </div>
                            )}
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                {/* Modal footer */}
                <div className="modal-footer">
                    <button type="button" className="btn Submit-btn" onClick={this.validate}>Save</button>
                    <button type="button" className="btn Cancel-btn" onClick={()=>this.props.clearEditModel()}>Cancel</button>
                </div>
                </div>
            </div>
            </div>
        );
    }
}

export default UploadQuestionBankModel;